import { render, staticRenderFns } from "./HSwiper.vue?vue&type=template&id=8036e3c6&scoped=true&"
import script from "./HSwiper.vue?vue&type=script&lang=js&"
export * from "./HSwiper.vue?vue&type=script&lang=js&"
import style0 from "./HSwiper.vue?vue&type=style&index=0&id=8036e3c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8036e3c6",
  null
  
)

export default component.exports